export default {
    received: payload => ({type: 'PUSH_NOTIFICATION_RECEIVED', payload})
};
